"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var Widget_1 = require("../tools/Widget");
var Accordion = (function (_super) {
    __extends(Accordion, _super);
    function Accordion(node, config) {
        var _this = _super.call(this, node, config) || this;
        jquery_1.default(_this.el).on('click', function () {
            jquery_1.default(this).toggleClass('active');
            jquery_1.default('[data-accordion-content="' + jquery_1.default(this).attr('data-accordion-tab') + '"]').slideToggle(400);
        });
        return _this;
    }
    return Accordion;
}(Widget_1.Widget));
exports.Accordion = Accordion;
